import type { HttpMock } from '#e2e-utils/mockScenarios';

export const freshCveMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '/customerVettings$',
    },
    response: {
      status: 200,
      body: [
        {
          customerVettingId: 'cveId',
          lineOfBusiness: 'TCI',
          companyId: '113',
          hasOpenIteration: false,
          iterations: [],
        },
      ],
    },
  },
];
